import React from 'react'
import { NavLink } from 'react-router-dom'
import Text from '../textStyleDefault/texto'

interface BotonContactoProps {
  texto: string
  onClick?: () => void
}

const BotonContacto = ({ texto, onClick }: BotonContactoProps): any => {
  return (
    <NavLink to="/contacto" onClick={onClick}>
      <Text
        as="button"
        className="active:opacity-25 transition-opacity duration-200 ease-in-out text-[#043873] bg-[#FFE492] text-nowrap text-center  w-[157px] h-[60px]  py-[21px] font-[500] text-[14px] rounded-[8px] leading-[125%] !tracking-[0.035px]"
      >
        {texto}
      </Text>
    </NavLink>
  )
}

export default BotonContacto
